module.exports = {"title":"About me","layout":"page","path":"/about","body":"<p>I am a full-stack developer with interests in business, real estate, and technology. When I am AFK I enjoy climbing, riding my bike, and drinking beer. One day I would like to start my own business. I also have dreams of living in a van.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./pages/about/index.md
// module id = 508
// module chunks = 0